<button
  class="
    box-search
    btn-default
    w-100
    d-flex
    align-items-center
    justify-content-center
  "
  (click)="onSearchOpen($event)"
>
  <mat-icon>add_circle_outline</mat-icon>
</button>
